<template lang="pug">
  .container.rows.wrapRWD
    .card(v-for="(type, index) in typeMapping", v-scroll-reveal={ origin: 'bottom' })
      font-awesome-icon(v-if="index === 'finance'", icon="file-invoice-dollar", size="3x")
      font-awesome-icon(v-if="index === 'regular'", icon="file-alt", size="3x")
      .title {{ type }}
      ul.rows
        li.item(v-for="report in getLastReports(index)")
          a(:href="report.url", target="_blank")
            .item-sub {{ report.year }}<br/>
            .item-title Q{{ report.quater }}
</template>

<script>
import Datas from '@/../static/json/reports.json'

export default {
  name: 'HomeCards',
  data () {
    return {
      typeMapping: {
        finance: '最新財報',
        regular: '最新季報'
      },
      reports: Datas
    }
  },
  methods: {
    getLastReports (type) {
      const sametype = this.reports.filter(s => s.type === type)
      return sametype.slice(0, 3)
    }
  }
}
</script>

<style lang="sass" scoped>

.card
  +fs($c: $c-black, $ta: center)
  padding: 20px
  border-radius: 2px
  background-color: #fff
  border: 1px $c-primary solid
  width: 0
  flex: 1 1 auto
  margin: 20px 10px
  svg
    color: $c-primary
    padding: 10px 0 20px
  .title
    +fs($fz: 32px)
    padding: 10px 0
  +rwd(mbl)
    padding: 12px
    .title
      padding: 6px 0

.item
  +fs($c: $c-smoke, $fz: 24px, $fw: 400)
  +pos($p: relative)
  width: 0
  flex: 1 1 auto
  margin: 10px
  border-radius: 2px
  padding: 12px
  &-title
    +fs($fz: 40px, $c: $c-smoke, $fw: 700)
  &:hover &-title
    +fs($c: $c-black)
  +rwd(mbl)
    padding: 4px 12px
    margin: 4px 10px
</style>



// WEBPACK FOOTER //
// src/components/HomeCards.vue